import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Pagination } from 'dg-pagination';
import { dgWithReducer } from 'dg-utils';
import { r as reducer } from './reducer-d2bd51aa.js';
import 'dg-pagination/dist/index.css';
import Swal from 'sweetalert2';
import { o as deletePost, f as fetchPosts, d as selectPost } from './post.actions-dcd472e5.js';

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListOptions = /*#__PURE__*/function (_Component) {
  _inherits(ListOptions, _Component);

  var _super = _createSuper$2(ListOptions);

  function ListOptions(props) {
    var _this;

    _classCallCheck(this, ListOptions);

    _this = _super.call(this, props);
    _this.state = {
      isDashboardsOpen: false
    };
    return _this;
  }

  _createClass(ListOptions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("nav", {
        className: "dg-admin-ListOptions"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "dg-admin-ListOptions-nav"
      }, /*#__PURE__*/React.createElement("li", {
        className: "nav-item ".concat(this.state.isDashboardsOpen ? "show" : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "nav-link dropdown",
        onClick: function onClick() {
          return _this2.setState({
            isDashboardsOpen: !_this2.state.isDashboardsOpen
          });
        }
      }, /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "ellipsis-v",
        className: "svg-inline--fa fa-ellipsis-v fa-w-6",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 192 512"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z",
        className: "fa-primary"
      })), /*#__PURE__*/React.createElement("div", {
        className: "dropdown-menu ".concat(this.state.isDashboardsOpen ? "show" : '')
      }, this.props.onEdit ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "dropdown-link",
        onClick: this.props.onEdit
      }, /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "edit",
        className: "svg-inline--fa fa-edit fa-w-18",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 576 512"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z",
        className: "fa-primary"
      })), /*#__PURE__*/React.createElement("span", {
        className: "link-text"
      }, "Edit")) : '', this.props.onDelete ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "dropdown-link",
        onClick: this.props.onDelete
      }, /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "trash-alt",
        className: "svg-inline--fa fa-trash-alt fa-w-14",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z",
        className: "fa-primary"
      })), /*#__PURE__*/React.createElement("span", {
        className: "link-text"
      }, "Delete")) : '')))));
    }
  }]);

  return ListOptions;
}(Component);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PostList = /*#__PURE__*/function (_Component) {
  _inherits(PostList, _Component);

  var _super = _createSuper$1(PostList);

  function PostList(props) {
    var _this;

    _classCallCheck(this, PostList);

    _this = _super.call(this, props);
    _this.onDelete = _this.onDelete.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PostList, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.newPost) {
        this.props.posts.unshift(nextProps.newPost);
      }
    }
  }, {
    key: "onDelete",
    value: function onDelete(event, data) {
      event.preventDefault();
      this.props.deletePost(data._id, data).then(function (res) {
        Swal.fire('Success', res.message, 'success');
      })["catch"](function (res) {
        Swal.fire('Error', res.message, 'error');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var postItems = [];

      if (this.props.posts.items && this.props.posts.items.length > 0) {
        postItems = this.props.posts.items.map(function (post) {
          return /*#__PURE__*/React.createElement("div", {
            className: "card mb-4 shadow-sm",
            key: "admin_post_list_".concat(post._id)
          }, /*#__PURE__*/React.createElement("div", {
            className: "card-body"
          }, /*#__PURE__*/React.createElement("button", {
            className: "btn-link",
            onClick: function onClick() {
              return _this2.props.onSelect(post);
            }
          }, post.title), /*#__PURE__*/React.createElement("h4", {
            className: "text-muted"
          }, "By ", post.created_by && post.created_by.displayName && post.created_by.displayName !== '' ? post.created_by.displayName : '', " - ", new Date(post.createdAt).toLocaleDateString('en-uk', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })), /*#__PURE__*/React.createElement("div", {
            className: "card-text",
            dangerouslySetInnerHTML: {
              __html: post.wysiwyg
            }
          })), /*#__PURE__*/React.createElement("div", {
            className: "card-options"
          }, /*#__PURE__*/React.createElement(ListOptions, {
            onDelete: function onDelete(e) {
              return _this2.onDelete(e, post);
            }
          })));
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "PostList-Admin"
      }, this.props.headerComponent ? this.props.headerComponent : /*#__PURE__*/React.createElement("h1", null, "Blog Posts"), postItems);
    }
  }]);

  return PostList;
}(Component);

var mapStateToProps$1 = function mapStateToProps(state) {
  return {
    posts: state.blogs
  };
};

var AdminPosts = connect(mapStateToProps$1, {
  deletePost: deletePost
})(PostList);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AdminPostList = /*#__PURE__*/function (_Component) {
  _inherits(AdminPostList, _Component);

  var _super = _createSuper(AdminPostList);

  function AdminPostList(props) {
    var _this;

    _classCallCheck(this, AdminPostList);

    _this = _super.call(this, props);
    _this.state = {
      page_size: 12,
      page: 0,
      total_pages: 0,
      total_items: 0,
      filter: {}
    };
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    _this.paginate = _this.paginate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AdminPostList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.paginate(this.state.page, this.state.page_size);
    }
  }, {
    key: "onSelect",
    value: function onSelect(post) {
      var _this2 = this;

      this.props.selectPost(post).then(function (data) {
        window.scrollTo(0, 0);

        _this2.props.history.push("/admin/posts/edit/".concat(post.slug || post._id));
      });
    }
  }, {
    key: "paginate",
    value: function paginate(page, page_size) {
      var _this3 = this;

      this.props.fetchPosts(page_size, page, this.state.filter).then(function (res) {
        _this3.setState({
          page_size: res.page_size,
          page: res.page,
          total_pages: res.total_pages,
          total_items: res.total_items
        });
      })["catch"](function (res) {
        console.log(res);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "redux-blogs-container"
      }, this.props.sidebar ? this.props.sidebar : "", /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement("div", {
        className: "redux-blogs-header-container"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "blog-list"
      }, /*#__PURE__*/React.createElement("li", {
        className: "blog-item"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/admin/posts/create",
        className: "btn-primary"
      }, "+ New Blog")))), /*#__PURE__*/React.createElement(AdminPosts, {
        onSelect: this.onSelect,
        headerComponent: this.props.headerComponent
      }), /*#__PURE__*/React.createElement(Pagination, {
        type: "Standard",
        paginate: function paginate(page, page_size) {
          return _this4.paginate(page, page_size);
        },
        page_size: this.state.page_size,
        page: this.state.page,
        total_pages: this.state.total_pages
      })));
    }
  }]);

  return AdminPostList;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    posts: state.blogs
  };
};

var adminPostList = connect(mapStateToProps, {
  fetchPosts: fetchPosts,
  selectPost: selectPost
})(dgWithReducer(AdminPostList, "blogs", reducer));

export { AdminPosts as A, adminPostList as a };
